import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Grid, Accordion, Loader, Icon} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {fullDate} from '../../../common/constants/datesFormat';
import Detail from './detail';
import Authorizer from './authorizer';
import Rejecter from './rejecter';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {'activeIndex': ''};
    this.handleTitleClick = this.handleTitleClick.bind(this);
  }

  handleTitleClick(event, data) {
    this.setState({
      'activeIndex': this.state.activeIndex === data.index ? '' : data.index,
    });
  }

  groupOrders(orders) {
    return orders.reduce((groupedOrders, element) => {
      const mainOrder = groupedOrders[element.orderCode] || {};
      const detail = mainOrder.list || [];
      const amount = mainOrder.amount || 0;

      return {
        ...groupedOrders,
        [element.orderCode]: {
          mainOrder,
          'list': [...detail, element],
          'date': element.authorizationRequest,
          'amount': amount + (element.totalFob || 0),
        },
      };
    }, {});
  }

  renderOrders() {
    const {orders} = this.props;
    const {activeIndex} = this.state;
    const groupedOrders = this.groupOrders(orders);
    const availableOrders = Object.keys(groupedOrders);

    return availableOrders.map((order, index) => {
      const currentOrder = groupedOrders[order];
      return (
        <React.Fragment key={index}>
          <Accordion.Title
            index={index}
            active={activeIndex === index}
            onClick={this.handleTitleClick}
          >
            <Grid>
              <Grid.Row>
                <Grid.Column width='15' textAlign='left'>
                  <div className='authorization-order-header'>
                    <strong>Pedido: {order}</strong>
                    | {moment(currentOrder.date).format(fullDate)}
                    | $ {getNumericValue(currentOrder.amount, 2)}
                  </div>
                </Grid.Column>
                <Grid.Column width='1' textAlign='right'>
                  <Icon name='dropdown' size='large' color='red' />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <Grid>
              <Grid.Row>
                <Grid.Column width='16' textAlign='center'>
                  <Rejecter orders={currentOrder.list} />
                  <Authorizer orders={currentOrder.list} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width='16'>
                  <Detail orders={currentOrder.list} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </React.Fragment>
      );
    });
  }

  render() {
    const {loading, orders} = this.props;

    if (loading) {
      return (
        <Loader active inline='centered'>Consultando...</Loader>
      );
    }

    if (!orders.length) {
      return (
        <div className='empty-authorization-list'>
          <h3>No se encontraron pedidos pendientes de autorización</h3>
        </div>
      );
    }

    return (
      <Accordion fluid styled>
        {this.renderOrders()}
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrdersAuthorization.loading,
    'orders': state.providerOrdersAuthorization.list,
  };
};

export default connect(mapStateToProps)(List);
